import { azureBlobLinkedServiceValidators } from 'shell-models-lib';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

azureBlobLinkedServiceValidators.validateAKVLinkedserviceReference = validateAKVLinkedserviceReference;
export { AzureStorageLinkedService } from 'shell-models-lib';
